/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';

import { Box } from '@mui/material';
import { BrandLogo } from 'src/components';
import { SignInContainer } from './components/SignInContainer';
import { SignInEmailSent } from './components/SignInEmailSent';

import { loginReferrer, referFriendSelectors } from 'src/redux/referFriend';
import { useSearchParams } from 'react-router-dom';

export const ReferFriendSignIn: React.FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const authEmailSentTo = useAppSelector(
    referFriendSelectors.getAuthEmailSentTo,
  );

  useEffect(() => {
    const tempToken = searchParams.get('token');

    if (tempToken) {
      dispatch(loginReferrer({ emailToken: tempToken }));
    }
  }, []);

  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.background.backgroundPrimary,
        minWidth: '100%',
        minHeight: '100%',
        padding: '41px 16px',
        [theme.breakpoints.down('lg')]: {
          paddingTop: '130px',
        },
      })}
    >
      <Box sx={{ position: 'absolute', top: '49px', left: '66px' }}>
        <BrandLogo width={133} />
      </Box>
      <Box display="flex" alignItems="center" flexDirection="column">
        {authEmailSentTo ? <SignInEmailSent /> : <SignInContainer />}
      </Box>
    </Box>
  );
};
